<template>
    <span>

    <header id="header">
    <div class="container">

      <div id="logo" class="pull-left">
         <b-link class="navbar-brand" to="/acesso">
             <h1 style="display: none">Teste</h1>
        <h5 class="navbar-brand-full" width="50" height="25" alt="SINDH Desaparecidos">ATENDELIBRAS</h5>
      </b-link>
      </div>
    </div>
  </header>
      <main id="main">
        <section id="schedule" class="section-with-bg">
            <br><br><br>
            <div class="container wow fadeInUp">
              <div class="section-header">
              <h2>Veja o vídeo abaixo e selecione a resposta correta!</h2>
            </div>
                <div class="tab-content row justify-content-center">
                    <div role="tabpanel" class="col-lg-11 tab-pane fade show active" id="day-1">
                        <video :src="captchaSimular.video" controls id="video1" style="width: 100%; height: auto; margin:0 auto; frameborder:0;"></video>
                        <b-form>
                <br>
                <br>
                <h3>Respostas</h3>
                <p>(Selecione a resposta corrreta)</p>
                 <b-container fluid class="p-4">
                    <span v-if="captchaSimular.numero_alternativas === 3">
                        <b-row>
                            <b-col cols="6" md="4" sm="6">
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[0].correta)" alt="Resposta 1" v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[0].foto"></b-img>
                            </b-col>
                             <b-col cols="6" md="4" sm="6">
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[1].correta)" alt="Resposta 2" v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[1].foto"></b-img>
                            </b-col>
                             <b-col cols="6" md="4" sm="6">
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[2].correta)" alt="Resposta 3" v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[2].foto"></b-img>
                            </b-col>
                        </b-row>
                    </span>
                    <span v-if="captchaSimular.numero_alternativas === 6">
                        <b-row>
                            <b-col cols="6" md="4" sm="6">
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[0].correta)" alt="Resposta 1"  v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[0].foto"></b-img>
                            </b-col>
                             <b-col cols="6" md="4" sm="6">
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[1].correta)" alt="Resposta 2" v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[1].foto"></b-img>
                            </b-col>
                             <b-col cols="6" md="4" sm="6">
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[2].correta)" alt="Resposta 3" v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[2].foto"></b-img>
                                <br><br>
                             </b-col>
                            <b-col cols="6" md="4" sm="6">
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[3].correta)" alt="Resposta 4" v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[3].foto"></b-img>
                            </b-col>
                             <b-col cols="6" md="4" sm="6">
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[4].correta)" alt="Resposta 5" v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[4].foto"></b-img>
                            </b-col>
                             <b-col cols="6" md="4" sm="6">
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[5].correta)" alt="Resposta 6" v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[5].foto"></b-img>
                            </b-col>
                        </b-row>
                    </span>
                    <span v-if="captchaSimular.numero_alternativas === 9">
                        <b-row>
                            <b-col cols="6" md="4" sm="6">
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[0].correta)" alt="Resposta 1" v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[0].foto"></b-img>
                            </b-col>
                             <b-col cols="6" md="4" sm="6">
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[1].correta)" alt="Resposta 2" v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[1].foto"></b-img>
                            </b-col>
                             <b-col cols="6" md="4" sm="6">
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[2].correta)" alt="Resposta 3" v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[2].foto"></b-img>
                                <br><br>
                             </b-col>
                            <b-col cols="6" md="4" sm="6">
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[3].correta)" alt="Resposta 4" v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[3].foto"></b-img>
                            </b-col>
                             <b-col cols="6" md="4" sm="6">
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[4].correta)" alt="Resposta 5" v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[4].foto"></b-img>
                            </b-col>
                             <b-col cols="6" md="4" sm="6">
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[5].correta)" alt="Resposta 6" v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[5].foto"></b-img>
                                <br><br>
                             </b-col>
                            <b-col cols="6" md="4" sm="6">
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[6].correta)" alt="Resposta 7" v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[6].foto"></b-img>
                            </b-col>
                             <b-col cols="6" md="4" sm="6">
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[7].correta)" alt="Resposta 8" v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[7].foto"></b-img>
                            </b-col>
                             <b-col cols="6" md="4" sm="6">
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[8].correta)" alt="Resposta 9" v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[8].foto"></b-img>
                            </b-col>
                        </b-row>
                    </span>
                </b-container>
                <div>
                 <b-alert show variant="success" v-if="respostaCerta">
                   <h4 class="alert-heading">Parabéns!</h4>
                   <p>Sua resposta está correta :)</p>
                   <p>O sistema está sendo redirecionado para...</p>
                 </b-alert>
                    <b-modal :hide-footer="true" title="Resposta Errada" headerTextVariant="primary" ok-title="ok" class="modal-danger" v-model="respostaErrada" id="modal-center" centered>
                        <h4 class="my-12">Você errou a resposta!&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b-button size="sm" @click="respostaErrada = !respostaErrada"> <i class="fa fa-thumbs-up"></i> Tentar novamente!</b-button></h4>
                    </b-modal>
                </div>
           </b-form>
                    </div>
                </div>
            </div>
        </section>
      </main>

      <footer id="footer">
        <div class="container">
            <div class="copyright"><strong>ATENDE LIBRAS</strong></div>
        </div>
      </footer>

      <a class="back-to-top"><i class="fa fa-angle-up"></i></a>
    </span>
</template>

<script>
import Vue from 'vue'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'

export default {
  name: 'SiteTemplate',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  created () {
    this.$store.dispatch('getCaptchaRandom')
  },
  data () {
    return {
      url: '',
      mainProps: {width: 250, height: 250},
      videoSimular: '',
      respostaFinal: false,
      countadorErros: 0,
      tentativas: 1,
      respostaErrada: false,
      respostaCerta: false,
      modalSimular: false,
      totalPorPagina: 1,
      resource: 'captcha',
      filtros: {
        filter: '',
        status: null
      }
    }
  },
  mounted () {
    $('#barraBrasilCustom').show()
  },
  computed: {
    captchaSimular () {
      return this.$store.state.captcha.captcha
    },
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label)
    }
  },
  watch: {
    'captchaSimular': function () {
      this.videoSimular = this.captchaSimular.video
    },
    'countadorErros': function () {
      if (this.countadorErros === 2) {
        this.$router.push('/captcha-erro')
        return false
      }
    }
  },
  methods: {
    trocar: function () {
      this.$store.dispatch('getCaptchaRandom', this.captchaSimular.id)
    },
    informarRespostaCerta (resposta) {
      if (resposta) {
        this.respostaCerta = true
        this.respostaErrada = false
        this.countadorErros = 0
        if (!this.respostaFinal) {
          if (this.tentativas === 1) {
            this.tentativas = this.tentativas
          } else {
            this.tentativas = this.tentativas + 1
          }
        }
        this.respostaFinal = true

        Vue.http.post('api/urlSucesso', {}).then(response => {
              this.url = response.body.data.url;
              setTimeout(function () { window.location.href = this.url }.bind(this), 3000)
              return false
          });
      } else {
        this.respostaCerta = false
        this.respostaErrada = true
        this.countadorErros = this.countadorErros + 1
        this.tentativas = this.countadorErros
        this.respostaFinal = false
        this.$store.dispatch('getCaptchaRandom', this.captchaSimular.id)
      }
    }
  }
}
</script>

<style lang="scss">
    // CoreUI Icons Set
    @import '@coreui/icons/css/coreui-icons.min.css';
    /* Import Font Awesome Icons Set */
    $fa-font-path: '~font-awesome/fonts/';
    @import '~font-awesome/scss/font-awesome.scss';
    /* Import Simple Line Icons Set */
    $simple-line-font-path: '~simple-line-icons/fonts/';
    @import '~simple-line-icons/scss/simple-line-icons.scss';
    /* Import Flag Icons Set */
    @import 'flag-icon-css/css/flag-icon.min.css';
    /* Import Bootstrap Vue Styles */
    @import 'bootstrap-vue/dist/bootstrap-vue.css';
    // Import Main styles for this application
    @import '../../assets/scss/style';

    .action{
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/templates/site-externo/CaptchaExterno.vue